import AuctionDetails from "../components/AuctionListing/AuctionDetails";
import Details from "../components/AuctionListing/Details";
import Icon from "../components/AuctionListing/Icon";
import Image from "../components/AuctionListing/Image";
import MapLocation from "../components/AuctionListing/MapLocation";
import SellerDescription from "../components/AuctionListing/SellerDescription";
import Container from "../components/layout/Container";

const Demo = () => {
  return (
    <div className="scale-50">
      {" "}
      <Container>
        <Icon />
        <div className="flex items-start justify-between">
          <div>
            <Image />
            <Details />
          </div>
          <div>
            <AuctionDetails />
            <SellerDescription />
            <MapLocation />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Demo;
